export default __webpack_public_path__ + "static/network-explorer@2x-65d5b3ee1f4e8ffef7bd18be70a76b11.png";